var HF_CONFIG = {
  emailjsPublicKey: 'ePtIqIeHbGw8QAW53',
  emailjsServiceId: 'service_yzg7lxm',
  emailjsTemplateId: 'template_270pjxw',
  adminEmail: 'hopesflorist@gmail.com',
  addonMap: { flowers: 'cake', cake: 'flowers' }
};

var HF_SLOTS = [
  { label: '9:00 AM – 11:00 AM', start: 9 },
  { label: '11:00 AM – 1:00 PM', start: 11 },
  { label: '1:00 PM – 3:00 PM', start: 13 },
  { label: '3:00 PM – 5:00 PM', start: 15 },
  { label: '5:00 PM – 7:00 PM', start: 17 },
  { label: '7:00 PM – 9:00 PM', start: 19 }
];

(function () {
  var productForm = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!productForm) return;

  productForm.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var variantInput = productForm.querySelector('input[name="id"]');
    var qtyEl = productForm.querySelector('input[name="quantity"]');
    var variantId = variantInput ? variantInput.value : '';
    var qty = qtyEl ? qtyEl.value : '1';
    var collection = (typeof window.HF_PRODUCT_COLLECTION !== 'undefined' && window.HF_PRODUCT_COLLECTION)
      ? window.HF_PRODUCT_COLLECTION
      : 'flowers';

    if (!variantId) {
      console.warn('[HF] Variant ID missing on product form.');
      return;
    }

    window.location.href =
      '/pages/order-details?variant=' +
      encodeURIComponent(variantId) +
      '&qty=' +
      encodeURIComponent(qty) +
      '&source=' +
      encodeURIComponent(collection);
  }, true);
})();

(function () {
  var orderForm = document.getElementById('hf-order-form');
  if (!orderForm) return;

  var params = new URLSearchParams(window.location.search);
  var variantId = params.get('variant');
  var qty = params.get('qty') || '1';
  var source = params.get('source') || 'flowers';

  if (!variantId) {
    window.location.href = '/';
    return;
  }

  var selectedAddons = [];
  var dateInput = document.getElementById('hf-delivery-date');
  var timeSelect = document.getElementById('hf-delivery-time');

  function getTodayStr() {
    var d = new Date();
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    return d.getFullYear() + '-' + mm + '-' + dd;
  }

  function updateTimeSlots(selectedDate) {
    if (!timeSelect) return;

    var isToday = selectedDate === getTodayStr();
    var nowHour = new Date().getHours();
    var available = HF_SLOTS.filter(function (slot) {
      return isToday ? slot.start > nowHour : true;
    });

    timeSelect.innerHTML = '';

    if (available.length === 0) {
      timeSelect.innerHTML = '<option value="">No slots available today</option>';
      var noSlotsMsg = document.getElementById('hf-no-slots-msg');
      if (noSlotsMsg) {
        noSlotsMsg.style.display = 'block';
        noSlotsMsg.textContent = 'No slots left for today. Please select tomorrow.';
      }
      return;
    }

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select a time slot';
    timeSelect.appendChild(placeholder);

    available.forEach(function (slot) {
      var opt = document.createElement('option');
      opt.value = slot.label;
      opt.textContent = slot.label;
      timeSelect.appendChild(opt);
    });

    var noSlotsMsg = document.getElementById('hf-no-slots-msg');
    if (noSlotsMsg) noSlotsMsg.style.display = 'none';
  }

  if (dateInput) {
    var today = new Date();
    var maxDate = new Date();
    maxDate.setDate(today.getDate() + 30);

    dateInput.min = getTodayStr();
    dateInput.max = maxDate.toISOString().split('T')[0];
    dateInput.value = getTodayStr();
    updateTimeSlots(getTodayStr());

    dateInput.addEventListener('change', function () {
      updateTimeSlots(this.value);
      this.classList.remove('hf-input-error');
      var err = this.nextElementSibling;
      if (err && err.classList.contains('hf-error-msg')) err.textContent = '';
    });
  }

  fetch('/variants/' + encodeURIComponent(variantId) + '.json')
    .then(function (r) {
      if (!r.ok) throw new Error('Variant not found');
      return r.json();
    })
    .then(function (d) {
      var v = d.variant;
      var price = Math.round(parseInt(v.price, 10) / 100);
      var s = document.getElementById('hf-product-summary');

      if (s) {
        s.innerHTML =
          '<div class="hf-summary-box">' +
            '<p class="hf-summary-label">Your Order</p>' +
            '<div class="hf-summary-product">' +
              '<span class="hf-summary-name">' + esc(v.product_title || v.title) + '</span>' +
              '<span class="hf-summary-qty">Qty: ' + esc(qty) + '</span>' +
              '<span class="hf-summary-price">&#8377;' + price + '</span>' +
            '</div>' +
          '</div>';
      }

      window._hfTitle = v.product_title || v.title || '';
      window._hfPrice = price || '';
    })
    .catch(function (err) {
      console.warn('[HF] Product summary load failed:', err);
    });

  var addonCollection = HF_CONFIG.addonMap[source] || 'cake';
  var titleEl = document.getElementById('hf-addon-title');

  if (titleEl) {
    titleEl.textContent = source === 'flowers'
      ? '🎂 Add a Cake to your order!'
      : '🌸 Add Flowers to your order!';
  }

  fetch('/collections/' + encodeURIComponent(addonCollection) + '/products.json?limit=12')
    .then(function (r) { return r.json(); })
    .then(function (d) {
      var grid = document.getElementById('hf-addons-grid');
      if (!grid) return;

      if (!d.products || !d.products.length) {
        grid.innerHTML = '<p class="hf-addon-empty">No add-ons available.</p>';
        return;
      }

      var cardsHTML = d.products.map(function (p) {
        var v = p.variants && p.variants.length ? p.variants[0] : null;
        if (!v) return '';

        var img = p.images && p.images.length ? p.images[0].src : '';
        var price = Math.round(parseFloat(v.price));

        return (
          '<div class="hf-carousel-card" data-variant-id="' + v.id + '">' +
            (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '<div class="hf-addon-no-img">🌸</div>') +
            '<div class="hf-carousel-info">' +
              '<p class="hf-carousel-name">' + esc(p.title) + '</p>' +
              '<p class="hf-carousel-price">&#8377;' + price + '</p>' +
            '</div>' +
            '<button type="button" class="hf-addon-btn" onclick="window.hfToggleAddon(this)">+ Add</button>' +
          '</div>'
        );
      }).join('');

      grid.innerHTML =
        '<div class="hf-carousel-wrapper">' +
          '<button type="button" class="hf-carousel-btn" id="hf-prev-btn">&#8249;</button>' +
          '<div class="hf-carousel-outer">' +
            '<div class="hf-carousel-track" id="hf-carousel-track">' + cardsHTML + '</div>' +
          '</div>' +
          '<button type="button" class="hf-carousel-btn" id="hf-next-btn">&#8250;</button>' +
        '</div>' +
        '<div class="hf-carousel-dots" id="hf-carousel-dots"></div>';

      initCarousel(d.products.length);
    })
    .catch(function () {
      var grid = document.getElementById('hf-addons-grid');
      if (grid) grid.innerHTML = '<p class="hf-addon-empty">Could not load add-ons.</p>';
    });

  function initCarousel(total) {
    var track = document.getElementById('hf-carousel-track');
    var prevBtn = document.getElementById('hf-prev-btn');
    var nextBtn = document.getElementById('hf-next-btn');
    var dotsEl = document.getElementById('hf-carousel-dots');
    if (!track || !prevBtn || !nextBtn) return;

    var currentIndex = 0;

    function getItemsPerView() {
      return window.innerWidth <= 480 ? 1 : window.innerWidth <= 768 ? 2 : 3;
    }

    function getMaxIndex() {
      return Math.max(0, total - getItemsPerView());
    }

    function getTotalPages() {
      return Math.ceil(total / getItemsPerView());
    }

    function getCurrentPage() {
      return Math.floor(currentIndex / getItemsPerView());
    }

    function buildDots() {
      if (!dotsEl) return;

      var html = '';
      for (var i = 0; i < getTotalPages(); i++) {
        html += '<button type="button" class="hf-carousel-dot' + (i === getCurrentPage() ? ' hf-dot-active' : '') + '" data-page="' + i + '"></button>';
      }

      dotsEl.innerHTML = html;

      dotsEl.querySelectorAll('.hf-carousel-dot').forEach(function (dot) {
        dot.addEventListener('click', function () {
          slideTo(parseInt(this.getAttribute('data-page'), 10) * getItemsPerView());
        });
      });
    }

    function updateDots() {
      if (!dotsEl) return;
      dotsEl.querySelectorAll('.hf-carousel-dot').forEach(function (dot, i) {
        dot.classList.toggle('hf-dot-active', i === getCurrentPage());
      });
    }

    function slideTo(index) {
      currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
      var firstCard = track.children[0];
      if (!firstCard) return;

      track.style.transform = 'translateX(-' + (currentIndex * (firstCard.offsetWidth + 16)) + 'px)';
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
      updateDots();
    }

    prevBtn.addEventListener('click', function () {
      slideTo(currentIndex - 1);
    });

    nextBtn.addEventListener('click', function () {
      slideTo(currentIndex + 1);
    });

    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          slideTo(currentIndex + 1);
        } else {
          slideTo(currentIndex - 1);
        }
      }
    }, { passive: true });

    window.addEventListener('resize', function () {
      buildDots();
      slideTo(currentIndex);
    });

    buildDots();
    slideTo(0);
  }

  window.hfToggleAddon = function (btn) {
    var card = btn.closest('.hf-carousel-card');
    if (!card) return;

    var id = parseInt(card.getAttribute('data-variant-id'), 10);
    if (!id) return;

    if (card.classList.contains('hf-addon-selected')) {
      card.classList.remove('hf-addon-selected');
      btn.textContent = '+ Add';
      selectedAddons = selectedAddons.filter(function (itemId) {
        return itemId !== id;
      });
    } else {
      card.classList.add('hf-addon-selected');
      btn.textContent = '✓ Added';
      selectedAddons.push(id);
    }
  };

  orderForm.addEventListener('submit', function (e) {
    e.preventDefault();

    if (!validateForm()) return;

    var btnText = document.getElementById('hf-btn-text');
    var btnLoader = document.getElementById('hf-btn-loader');
    var btn = document.getElementById('hf-place-order-btn');

    if (btnText) btnText.hidden = true;
    if (btnLoader) btnLoader.hidden = false;
    if (btn) btn.disabled = true;

    var senderName = document.getElementById('hf-sender-name').value.trim();
    var senderPhone = document.getElementById('hf-sender-phone').value.trim();
    var recipientName = document.getElementById('hf-recipient-name').value.trim();
    var recipientPhone = document.getElementById('hf-recipient-phone').value.trim();
    var address = document.getElementById('hf-recipient-address').value.trim();
    var pincode = document.getElementById('hf-pincode').value.trim();
    var addressType = document.getElementById('hf-address-type').value;
    var deliveryDateVal = document.getElementById('hf-delivery-date').value;
    var deliveryTime = document.getElementById('hf-delivery-time').value;
    var note = document.getElementById('hf-note').value.trim() || 'N/A';
    var deliveryDay = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][
      new Date(deliveryDateVal + 'T00:00:00').getDay()
    ];

    document.getElementById('hf-variant-id-hidden').value = variantId;
    document.getElementById('hf-quantity-hidden').value = qty;

    document.getElementById('hf-prop-sender-name').value = senderName;
    document.getElementById('hf-prop-sender-phone').value = senderPhone;
    document.getElementById('hf-prop-recipient-name').value = recipientName;
    document.getElementById('hf-prop-recipient-phone').value = recipientPhone;
    document.getElementById('hf-prop-address').value = address;
    document.getElementById('hf-prop-pincode').value = pincode;
    document.getElementById('hf-prop-address-type').value = addressType;
    document.getElementById('hf-prop-delivery-date').value = deliveryDateVal;
    document.getElementById('hf-prop-delivery-day').value = deliveryDay;
    document.getElementById('hf-prop-delivery-time').value = deliveryTime;
    document.getElementById('hf-prop-note').value = note;

    document.getElementById('hf-attr-sender-name').value = senderName;
    document.getElementById('hf-attr-sender-phone').value = senderPhone;
    document.getElementById('hf-attr-recipient-name').value = recipientName;
    document.getElementById('hf-attr-recipient-phone').value = recipientPhone;
    document.getElementById('hf-attr-address').value = address;
    document.getElementById('hf-attr-pincode').value = pincode;
    document.getElementById('hf-attr-address-type').value = addressType;
    document.getElementById('hf-attr-delivery-date').value = deliveryDateVal;
    document.getElementById('hf-attr-delivery-day').value = deliveryDay;
    document.getElementById('hf-attr-delivery-time').value = deliveryTime;
    document.getElementById('hf-attr-note').value = note;

    function submitToShopify() {
      orderForm.submit();
    }

    if (typeof emailjs !== 'undefined') {
      emailjs.send(
        HF_CONFIG.emailjsServiceId,
        HF_CONFIG.emailjsTemplateId,
        {
          admin_email: HF_CONFIG.adminEmail,
          product_name: window._hfTitle || '',
          product_price: window._hfPrice || '',
          quantity: qty,
          sender_name: senderName,
          sender_phone: senderPhone,
          receiver_name: recipientName,
          receiver_phone: recipientPhone,
          address: address,
          pincode: pincode,
          address_type: addressType,
          delivery_date: deliveryDateVal,
          delivery_day: deliveryDay,
          delivery_time: deliveryTime,
          note: note
        }
      ).catch(function (emailErr) {
        console.warn('[HF] Email failed, continuing:', emailErr);
      }).finally(function () {
        submitToShopify();
      });
    } else {
      submitToShopify();
    }
  });

  function validateForm() {
    var valid = true;
    var fields = [
      { id: 'hf-sender-name', msg: 'Please enter your name' },
      { id: 'hf-sender-phone', msg: 'Please enter a valid 10-digit phone', type: 'phone' },
      { id: 'hf-recipient-name', msg: "Please enter receiver's name" },
      { id: 'hf-recipient-phone', msg: 'Please enter a valid 10-digit phone', type: 'phone' },
      { id: 'hf-recipient-address', msg: 'Please enter delivery address' },
      { id: 'hf-pincode', msg: 'Please enter a valid 6-digit pincode', type: 'pincode' },
      { id: 'hf-address-type', msg: 'Please select address type' },
      { id: 'hf-delivery-date', msg: 'Please select a delivery date' },
      { id: 'hf-delivery-time', msg: 'Please select a delivery time slot' }
    ];

    fields.forEach(function (f) {
      var el = document.getElementById(f.id);
      var err = el ? el.nextElementSibling : null;
      if (!el) return;

      var v = (el.value || '').trim();
      var ok = v !== '';

      if (ok && f.type === 'phone') ok = /^[6-9][0-9]{9}$/.test(v);
      if (ok && f.type === 'pincode') ok = /^[0-9]{6}$/.test(v);

      if (!ok) {
        el.classList.add('hf-input-error');
        if (err && err.classList.contains('hf-error-msg')) err.textContent = f.msg;

        if (valid) {
          el.focus();
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        valid = false;
      } else {
        el.classList.remove('hf-input-error');
        if (err && err.classList.contains('hf-error-msg')) err.textContent = '';
      }
    });

    return valid;
  }

  document.querySelectorAll('#hf-order-form input, #hf-order-form select, #hf-order-form textarea').forEach(function (el) {
    el.addEventListener('input', function () {
      el.classList.remove('hf-input-error');
      var err = el.nextElementSibling;
      if (err && err.classList.contains('hf-error-msg')) err.textContent = '';
    });

    el.addEventListener('change', function () {
      el.classList.remove('hf-input-error');
      var err = el.nextElementSibling;
      if (err && err.classList.contains('hf-error-msg')) err.textContent = '';
    });
  });

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
})();